module.exports = __webpack_public_path__ + "img/logo-company.38b76c89.png";